import React, { Suspense } from "react";
import classes from "./cartTrigger.module.css";
import { GET_ITEM_COUNT_QUERY } from "../../Pregrine/cartTrigger/cartTrigger.gql";
import { useCartTrigger } from "../../Pregrine/cartTrigger/useCartTrigger";

const MiniCart = React.lazy(() => import("../MiniCart"));

const CartTrigger = (props) => {
  const {
    handleTriggerClick,
    itemCount,
    miniCartRef,
    miniCartIsOpen,
    hideCartTrigger,
    setMiniCartIsOpen,
    miniCartTriggerRef,
    loading,
  } = useCartTrigger({
    queries: {
      getItemCountQuery: GET_ITEM_COUNT_QUERY,
    },
  });

  const buttonAriaLabel = `Toggle mini cart. You have ${itemCount} items in your cart.`;

  const itemCountDisplay = itemCount > 99 ? "99+" : itemCount;

  const triggerClassName = miniCartIsOpen
    ? classes.triggerContainer_open
    : classes.triggerContainer;

  const cartTrigger = hideCartTrigger ? null : (
    <div className={classes.rootRelative}>
      <div className={triggerClassName} ref={miniCartTriggerRef}>
        <button
          aria-label={buttonAriaLabel}
          className={classes.trigger}
          onClick={handleTriggerClick}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 24 24"
          >
            <path
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="m19.26 9.696l1.385 9A2 2 0 0 1 18.67 21H5.33a2 2 0 0 1-1.977-2.304l1.385-9A2 2 0 0 1 6.716 8h10.568a2 2 0 0 1 1.977 1.696ZM14 5a2 2 0 1 0-4 0"
            />
          </svg>
          <span className={classes.counter}>{itemCountDisplay}</span>
        </button>
      </div>

      <Suspense fallback={null}>
        {miniCartIsOpen ? (
          <MiniCart
            isOpen={miniCartIsOpen}
            setIsOpen={setMiniCartIsOpen}
            ref={miniCartRef}
            loading={loading}
          />
        ) : null}
      </Suspense>
    </div>
  );

  return cartTrigger;
};

export default CartTrigger;
